<script>
    import { layoutMethods, prpMethods, prpComputed, erpUserRolesMethods} from "@/state/helpers";
    // import { required } from "vuelidate/lib/validators";
    // import ImageUploader from "@/components/ImageUploader";
    import Swal from "sweetalert2";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    // import moment from "moment";
    import { getModuleAccess } from '@/router/helper.js'

    export default {
      page: {
        title: "Redemption Reward"
      },
      data() {
        return {
          title: "Redemption Reward",
          rewardId: 0,
          dataStatusList:[],
          iconLogo: {
            filename: null,
            type: null,
            base64: null,
          },
          details: {},
          form:{
              prpLogId                      : null,
              peddlrTrackingId              : null,
              courier                       : null,
              courierTrackingId             : null,
              deliveryStatus                : null,
              reward                        : null,
              rewardAmount                  : null,
              receiverName                  : null,
              receiverContactNumber         : null,
              receiverAddress               : null,
              receiverCity                  : null,
              receiverState                 : null,
              receiverRegion                : null,
              receiverCountry               : null,
              processedBy                   : null,
          },
          folder: 'roleta-images',
          isEditModal: false,
          hideAmount: true,
          hideStock: true,
          logoPreview: "",
          submitted: false,
          minDate: 'today',
          typeOptions:[
            {
              text: "Processing", 
              value: "Processing"
            },
            {
              text: "Sent for Delivery", 
              value: "Sent for Delivery"
            },
            {
              text: "Delivered", 
              value: "Delivered"
            },
            {
              text: "Cancelled", 
              value: "Cancelled"
            },
          ],
          prpRewardsModule: {
            access: {
              update: true
            }
          }
        };
      },
      components: {
        // ImageUploader,
        flatPickr,
      },
      
      
      methods: {
        ...layoutMethods,
        ...prpMethods,
        ...prpComputed,
        ...erpUserRolesMethods,
        onError(e){
          this.isDefault = true;
          this.imagePath = null;
          e.target.src = require('@/assets/images/img-placeholder.png')
        },
        retrieveData(peddlrTrackingId){
          this.logoPreview = null;
          this.getPrpReward(peddlrTrackingId).then((reward) => {
            console.log(reward);
            this.details = reward[0];
            this.dataStatusList = reward;
            return "success"
          })
          .catch(e => {
              console.log("error", e);
          });    
        },
        processData(){
          var data =  {
            ...this.details,
            processAction : this.form.processAction,
            courier : this.form.courier,
            date : this.form.date,
            newProcessedBy : this.form.processedBy,
            trackingNumber : this.form.trackingNumber, 
          }
          // console.log("params send",JSON.stringify(data));
          this.createRecordPRP(data)
          .then(() => {
            Swal.fire("Create Successful!", `PRP Reward has been processed.`,"success");
              this.$router.push(
                this.$route.query.redirectFrom || {
                  name: "Peddlr Points",
                }
              );    
          })
          
        }
      },
      computed: {
      },
      async mounted(){
        this.changeTitle({title: 'Redemption Reward'});
        this.peddlrTrackingId = this.$route.params.peddlrTrackingId;
        if (this.peddlrTrackingId) {
          await this.retrieveData(this.peddlrTrackingId);
        }
        this.changeTitle({
          title: (this.peddlrTrackingId ? "Update" : "Add") + " Redemption Reward Details",
        });
        this.changeBreadCrumb({
          breadCrumbs: [
            { text: 'Peddlr', to: { name: 'Home'} },
            { text: 'Redemption Reward', to: { name: 'Redemption Reward'} },
            { text: 'Roleta Reward Details', to: { name: 'Redemption Reward'} },
          ]
        });

        // get the module access for checking if user has create, read, update, and/or delete access
        await getModuleAccess('Utilities', 'PRP', 'PRP Rewards')
        .then((access) => this.prpRewardsModule.access = access);

      }
    }
      
  </script>
  <template>
    <div class="">
      <ValidationObserver>
        <b-form>
          <div class="d-flex flex-md-row flex-column mb-3">
            <div class="pe-lg-2">
              <span class="me-2">
                <div class="preview-holder" style="width:200px;height:239px">
                  <img
                    :src="form.itemIconLink"
                    @error="onError"
                    class="img-fluid mx-auto d-block m-2 border border border-info item-logo"
                  />
                </div>
              </span>
            </div>
            <div class="px-lg-2">
              <div class="card">
                <div class="card-body" style="max-width: 620px">
                  <div class="row">
                    <label v-if="!prpRewardsModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a PRP Reward.</label>
                    <div class="col-md-12 mb-1">
                      <label class="form-label"
                        >Reward :</label
                      >
                        <span class="fw-bold"> {{details.reward}} </span>
                    </div>
                    <div class="col-md-12 mb-1">
                      <label class="form-label"
                        >ID Number:</label
                      >
                        <span class="fw-bold"> {{details.peddlrTrackingId}} </span>
                    </div>
                    <div class="col-md-12 mb-1">
                      <label class="form-label"
                        >Name : </label
                      >
                      <span class="fw-bold"> {{ details.receiverName }} </span>
                    </div>
                    <div class="col-md-12 mb-1">
                      <label class="form-label"
                        >Phone Number : </label
                      >
                      <span class="fw-bold"> {{ details.receiverContactNumber }}  </span>
                    </div>
                    <div class="col-md-12 mb-1">
                      <label class="form-label"
                        >Delivery Address: </label
                      >
                      <span class="fw-bold"> {{ details.receiverAddress }} </span>
                    </div>
                    <div class="col-md-12 mb-1">
                      <label class="form-label"
                        >Tracking Number: </label
                      >
                      <span class="fw-bold"> {{ details.courierTrackingId }}  </span>
                    </div>
                    <div class="col-md-12 mb-1">
                      <label class="form-label"
                        >Courier: </label
                      >
                      <span class="fw-bold"> {{ details.courier }}  </span>
                    </div>
                    <div class="col-md-12 mb-2" v-if="false">
                      <label class="form-label"
                        >Processed By: </label
                      >
                      <span class="fw-bold"> {{ details.processedBy }}  </span>
                    </div>
                    <div class="col-md-12 mb-1">
                      <label class="form-label"
                        >Delivery Status: </label
                      >
                      <div class="mb-2" v-for="(item) in dataStatusList" :key="item.id">
                        <span style="padding-left: 10px;" class="fw-bold text-capitalize" > 
                          {{item.deliveryStatus}} - 
                          {{ item.processedDate == null ? item.updated_at:item.processedDate | formatDateNoComma}} 
                          {{item.processedBy != null ? ` - Processed By: ${item.processedBy}`:""}}
                        </span>
                      </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4 mb-2">
                            <label class="form-label">Action</label>
                            <b-form-group id="input-group-3" label-for="input-3">
                                <b-form-select class="form-select rounded-0 rounded-start shadow-none w-150px" id="input-3" v-model="form.processAction" :options="typeOptions"></b-form-select>
                            </b-form-group>
                        </div>
                        <div class="col-md-4 mb-2">
                            <label class="form-label small fw-bold">Process By</label>
                            <b-form-input
                            type="text"
                            class="form-control"
                            placeholder="Enter name"
                            v-model="form.processedBy"
                            />
                        </div>
                        <div class="col-md-4 mb-2">
                            <label class="form-label">Date</label>
                            <b-form-group >
                                <flat-pickr v-model="form.date"
                                :config="{ minDate: minDate}"
                                placeholder="Select a date" class="form-control"></flat-pickr>
                            </b-form-group>
                        </div>
                        <div v-if="form.processAction == 'Sent for Delivery'" class="col-md-4 mb-2">
                            <label class="form-label small fw-bold">Courier</label>
                            <b-form-input
                            type="text"
                            class="form-control"
                            placeholder="Enter courier name"
                            v-model="form.courier"
                            />
                        </div>
                        <div v-if="form.processAction == 'Sent for Delivery'" class="col-md-4 mb-2">
                            <label class="form-label small fw-bold">Tracking Number</label>
                            <b-form-input
                            type="text"
                            class="form-control"
                            placeholder="Enter tracking number"
                            v-model="form.trackingNumber"
                            />
                        </div>
                    </div>
                    <b-row class="mb-3">
                      <b-col
                        ><b-btn :disabled="!prpRewardsModule.access.update" class="w-100" variant="primary" @click="processData()"
                          >Save</b-btn
                        >
                      </b-col>
                      <b-col>
                        <router-link :to="{ name: 'Peddlr Points', params: {} }" class="tc-white">
                            <b-button
                              variant="light"
                              class="w-sm w-100p"
                              type="button"
                              >Cancel</b-button
                            >
                        </router-link>
                        <!-- <b-btn class="w-100 btn btn-light" >
                          
                        </b-btn> -->
                      </b-col>
                    </b-row>  
                  </div>
               </div>
              </div>
              <!-- end of card-->
            </div>
            <!-- end of card form-->
          </div>
          <!--end of flex-->
        </b-form>
        <!-- end of the form--> 
      </ValidationObserver
      ><!-- end of validation observer-->
    </div>
    <!-- end of row-->
  </template>
  <!-- <template>
    <div>
        This is Roulette Main New Page
    </div>
  </template> -->
  
  <style>
    .form-label.item-percentage {
        color: #aaaaaa;
        font-size: 11px !important;
    }
    .multiselect.invalid .multiselect__tags {
    border-color: #f34e4e !important;
    padding-right: calc(1.5em + 0.94123rem) !important;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e") !important;
    background-repeat: no-repeat !important;
    background-position: right calc(0.375em + 0.235rem) center !important;
    background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem) !important;
  }
  
  .invalid ~ .invalid-feedback {
    display: block;
  }
  
  .multiselect__option--highlight,
  .multiselect__option--highlight::after {
    background: #f8f9fa;
    color: #495057;
  }
  
  .multiselect__tag {
    background-color: #e73092 !important;
    border-color: #e73092 !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
  }
  
  .multiselect__tag-icon:after {
    color: #fff !important;
  }
  
  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background-color: #e73092 !important;
  }
  </style>